<template>
    <select data-styler v-on:change="changeViewSettings()">
        <option>{{decodedData}}</option>
    </select>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "view-settings",

        props: [
            'settings_arr'
        ],

        data() {
            return {
                selfSelect: true,
            }
        },


        computed: {
            decodedData() { console.log(this.settings_arr)
                return JSON.parse(this.settings_arr);
            }
        },

        mounted() {
            console.log("sad");
        },

        methods: {
           /* changeViewSettings() {
                const formData = new FormData();
                formData.append('projectId', this.project_id);
                formData.append("handler", "projects");
                formData.append("func", "sendPdf");
                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data' // for POST requests
                axios.post('/ajax/common.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.sendMail = true;
                    this.$store.dispatch('project/getProjectLogoSchema', this.project_id);
                })
                    .catch(err => {
                        console.error(err);
                    });
            },*/


        }
    }


</script>